function clone(obj) {
  var copy;

  // Handle the 3 simple types, and null or undefined
  if (null == obj || "object" != typeof obj) return obj;

  // Handle Date
  if (obj instanceof Date) {
    copy = new Date();
    copy.setTime(obj.getTime());
    return copy;
  }

  // Handle Array
  if (obj instanceof Array) {
    copy = [];
    for (var i = 0, len = obj.length; i < len; i++) {
      copy[i] = clone(obj[i]);
    }
    return copy;
  }

  // Handle Object
  if (obj instanceof Object) {
    copy = {};
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
    }
    return copy;
  }

  throw new Error("Unable to copy obj! Its type isn't supported.");
}

var get_bemto_tag_type = function(tagName) {
  var result = 'block'
  if (bemto_tag_metadata[tagName]) {
    result = bemto_tag_metadata[tagName].type || result;
  }
  return result;
}

var get_bemto_tag_content_type = function(tagName) {
  var result = 'block'
  if (bemto_tag_metadata[tagName]) {
    result = bemto_tag_metadata[tagName].content_type || bemto_tag_metadata[tagName].type || result;
  }
  return result;
}

var bemto_tag_metadata = {
  'hr': {
    'type': 'self_closing'
  },
  'br': {
    'type': 'self_closing'
  },
  'wbr': {
    'type': 'self_closing'
  },
  'source': {
    'type': 'self_closing'
  },
  'img': {
    'type': 'self_closing'
  },
  'input': {
    'type': 'self_closing'
  },
  'a': {
    'type': 'inline'
  },
  'abbr': {
    'type': 'inline'
  },
  'acronym': {
    'type': 'inline'
  },
  'b': {
    'type': 'inline'
  },
  'code': {
    'type': 'inline'
  },
  'em': {
    'type': 'inline'
  },
  'font': {
    'type': 'inline'
  },
  'i': {
    'type': 'inline'
  },
  'ins': {
    'type': 'inline'
  },
  'kbd': {
    'type': 'inline'
  },
  'map': {
    'type': 'inline'
  },
  'pre': {
    'type': 'inline'
  },
  'samp': {
    'type': 'inline'
  },
  'small': {
    'type': 'inline'
  },
  'span': {
    'type': 'inline'
  },
  'strong': {
    'type': 'inline'
  },
  'sub': {
    'type': 'inline'
  },
  'sup': {
    'type': 'inline'
  },
  'textarea': {
    'type': 'inline'
  },
  'time': {
    'type': 'inline'
  },
  'label': {
    'content_type': 'inline'
  },
  'p': {
    'content_type': 'inline'
  },
  'h1': {
    'content_type': 'inline'
  },
  'h2': {
    'content_type': 'inline'
  },
  'h3': {
    'content_type': 'inline'
  },
  'h4': {
    'content_type': 'inline'
  },
  'h5': {
    'content_type': 'inline'
  },
  'h6': {
    'content_type': 'inline'
  },
  'ul': {
    'content_type': 'list'
  },
  'ol': {
    'content_type': 'list'
  },
  'select': {
    'content_type': 'optionlist'
  },
  'datalist': {
    'content_type': 'optionlist'
  }
}

export {clone, bemto_tag_metadata, get_bemto_tag_content_type, get_bemto_tag_type}
